// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';

export const updateSessionExpiredModalVisibility = isVisible =>

    dispatch => {

        dispatch({
            isVisible,
            type: actions.UPDATE_SESSION_EXPIRED_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/session-expired-modal-visibility.js